var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { usePath } from '@frctl/react/components';
export const defaultContext = {
    getIconPath: (name) => name,
    breakPoints: {
        xs: 320,
        sm: 600,
        md: 800,
        lg: 1000,
        xl: 1200,
    },
    locale: undefined,
};
export const ThemeContext = React.createContext(defaultContext);
const ThemeProviderCore = (props) => {
    const { children, getIconPath } = props, rest = __rest(props, ["children", "getIconPath"]);
    const path = usePath();
    return (React.createElement(ThemeContext.Provider, { value: Object.assign(Object.assign({}, rest), { getIconPath: (iconPath) => path.get(getIconPath(iconPath)) }) }, children));
};
export default ThemeProviderCore;
